module.exports = __webpack_public_path__ + "static/carousel2-8657d4f4a368f2faaca3173c183e9399.jpg";